<template>
	<v-radio-group v-model="radios.radioSelected">
		<v-layout align-center v-if="$route.name == 'counseling-list'">
			<v-radio
				class="mx-2 mb-0"
				v-for="(radio, i) in items"
				:key="i"
				:label="radio.label"
				:value="radio.value"
				:ripple="false"
				:color="radios.color"
			></v-radio>
		</v-layout>
		<v-layout align-center v-else>
			<v-radio
				class="mx-2 mb-0"
				:class="radios.shadow ? 'btnZindex1' : ''"
				v-for="(radio, i) in radios.items"
				:key="i"
				:label="radio.label"
				:value="radio.value"
				:ripple="false"
				:color="radios.color"
				@click="$emit('click', $event)"
			></v-radio>
		</v-layout>
	</v-radio-group>
</template>

<script>
export default {
	props: {
		radios: Object,
		items: Array,
		click: Function,
	},
	methods: {
		changeDummy() {},
	},
}
</script>

<style></style>
